import {defineComponent, ref} from 'vue'
import { useField, useForm, useFieldArray, ErrorMessage} from 'vee-validate'
import ru from 'yup-locale-ru'
import { host } from '@/const'
import axios from '@/axios'
import * as yup from 'yup'
import './style.sass'
import Preloader from "@/components/preloader/preloader.vue";
import PersonalDataCheckbox from "@/components/personal-data-checkbox";

export default defineComponent({
  props: {
    cancel: {
      type: Function,
      default: (value: boolean) => value
    },
    order: {
      type: String,
      default: () => ''
    },
  },
  setup (props) {
    yup.setLocale(ru)

    const preloader = ref(false)
    const errorResponse = ref('')
    const statusError = ref('')
    const successResponse = ref(false)
    const endpoint = ref<string>('/api/v1/orders/cancel')

    const variantsStatuses = ref([
      {
        id: 1,
        value: 'В оплате',
        description: '(оплата находится на согласовании)'
      },
      {
        id: 2,
        value: 'Не устроила цена',
        description: '(предложили цену дешевле)'
      },
      {
        id: 3,
        value: 'Не устроили сроки',
        description: '(нашли с меньшим сроком поставки)'
      },
      {
        id: 4,
        value: 'Не устроило количество',
        description: '(предложенное количество не соответствует моему запросу)'
      },
      {
        id: 6,
        value: 'Запрашивал счёт для тендера/сметы',
      },
      {
        id: 7,
        value: 'Нет финансирования',
      },
      {
        id: 8,
        value: 'Закупка отложена'
      },
      {
        id: 9,
        value: 'Товар не соответствует запросу',
      },
      {
        id: 10,
        value: 'Качество обслуживания',
        description: '(качество работы менеджера)'
      },
      {
        id: 11,
        value: 'Долгое ожидание ответа',
      },
    ])

    function closeModal ($event: MouseEvent) {
      // @ts-ignore
      if ($event?.target?.classList.value === 'close' || $event?.target?.classList.value === 'overlay') {
        props.cancel(false)
      }
    }

    const schema = yup.object().shape(
      {
        statuses: yup.array().required().min(1),
        personalData: yup.boolean()
          // @ts-ignore
          .oneOf([true], "Вы не дали согласие")
          .test("only-yes", "Вы не дали согласие", value => value === true)
      }
    )

    type FormInputs = {
      statuses: Array<string>
      message: string,
      personalData: boolean
    }

    //@ts-ignore
    const { handleSubmit } = useForm<FormInputs>({ validationSchema: schema })

    const { push: setStatus, remove: removeStatus, fields: statuses } = useFieldArray<unknown>('statuses')
    // const { value: statuses, errorMessage: statusError } = useField<Array<string>>('statuses')
    const { value: message, errorMessage: messageError } = useField<string>('message')
    const { value: personalData, errorMessage: personalError } = useField<boolean | undefined>('personalData')
    personalData.value = false

    const onSubmit = handleSubmit(async () => {
      preloader.value = true
      const formData: FormData = new FormData()

      statuses.value.map((item, key) => {
        //@ts-ignore
        formData.append('statuses[]', item.value)
      })

      if (message.value) {
        formData.append('message', message.value)
      }
      formData.append('order', props.order)
      
      axios.post(`${host}${endpoint.value}`, formData)
        .then(json => {
          if (json.status === 200 || json.status === 201) {
            successResponse.value = true
          } else {            
            messageError.value = 'Ошибка запроса, попробуйте повторить позже'
          }
          
          preloader.value = false
        })
        .catch(e => {
          errorResponse.value = 'Ошибка запроса, попробуйте повторить позже'
          
        })
        .finally(() => {          
          preloader.value = false
        })
    })

    function setVariantStatus(variant: Record<string, unknown>) {

      statusError.value = ''

      if (Object.keys(statuses.value).length === 0) {        
        setStatus(variant.id)        
      } else {
        let isIssetElement: boolean = false

        statuses.value.map((item, key) => {
          if (item.value === variant.id) {
            isIssetElement = true
            removeStatus(key)
          }
        })

        if (!isIssetElement) {
          setStatus(variant.id)
        }
      }
    }

    function checkStatuses () {
      if(statuses.value.length <= 0) {
        statusError.value = 'Пожалуйста, укажите причину'
      }
    }

    return () => (
      <div class="overlay" onClick={($event) => closeModal($event)}>
        <div class="modal">
          <a class="close" onClick={($event) => closeModal($event)} />
          {successResponse.value === true
            ? (
              <div class="success-block">
                <div class="success-icon"/>
                <p>Ваша заявка по отмене взята в работу менеджером.</p>
              </div>
            )
            : (
              <div>
                <p>Пожалуйста, расскажите, что пошло не так?</p>
                <form onSubmit={values => onSubmit(values)}>
                  <div class="statuses">
                    {variantsStatuses.value.map(variantStatus => (
                      <div class="status">
                        <label>
                          <input
                            type="checkbox"
                            name={`${variantStatus.id}`}
                            value={variantStatus.value}
                            onClick={() => setVariantStatus(variantStatus)}
                          />
                          <div class="checkbox"/>
                          <span>{variantStatus.value}
                            {variantStatus.description
                              ? (<span class="description">{ variantStatus.description }</span>)
                              : null
                            }
                          </span>
                        </label>
                      </div>
                    ))}
                    {statusError.value
                      ? (<span class="error-message" style="text-align: left;">{statusError.value}</span>)
                      : null
                    }
                  </div>
                  <div class="text">
                    <textarea
                      v-focus
                      placeholder="Дополнительный комментарий"
                      v-model={message.value}
                    />
                    {messageError.value
                      ? (<span class="error-message" style="text-align: left;">{messageError.value}</span>)
                      : null
                    }
                    </div>
                  <PersonalDataCheckbox personalData={personalData} personalError={personalError} />
                  {preloader.value ?
                    <Preloader style="position: relative; margin: 25px auto;"/>
                    :
                    <button onClick={() => {checkStatuses()}}>Ответить</button>
                  }
                </form>
              </div>
            )
          }
        </div>
      </div>
    )
  }
})